import { Component } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-standard-footer",
	templateUrl: "./standard-footer.component.html",
	styleUrls: ["./standard-footer.component.scss"],
})
export class StandardFooterComponent {
	constructor() {}

	getFullYear(): number {
		return new Date().getFullYear();
	}

	get version(): string {
		return environment.version;
	}

	get hostname(): string {
		if (environment.production || environment.name == "STAGE") {
			return environment.hostname.slice(-2);
		} else {
			return environment.hostname;
		}
	}
}
